/* eslint-disable no-unused-vars */
const StyledSelect = require('./dropdowns');

const resetCrossClick = (htmlbutton, resetItem, monobutton) => {
    const buttonCross = htmlbutton.querySelector('.icon-dropdown-cross');
    const innerChange = htmlbutton.querySelector(
        '.js-button-dropdown-text-select'
    );

    buttonCross.addEventListener('click', (e) => {
        innerChange.innerText = resetItem;
        htmlbutton.classList.remove('sub-select-active');

        monobutton.addValue('default');

        monobutton.reset();

        if (typeof monobutton.settings.onChange === 'function') {
            monobutton.settings.onChange(monobutton);
        }

        e.stopPropagation();
        e.preventDefault();
    });
};

const resetButton = (htmlbutton, resetItem, monobutton) => {
    const innerChange = htmlbutton.querySelector(
        '.js-button-dropdown-text-select'
    );

    innerChange.innerText = resetItem;
    htmlbutton.classList.remove('sub-select-active');
    monobutton.addValue('default');

    monobutton.reset();
};

export const instances = () => {
    let monthSelect;
    const siteSearchOrderButton = document.querySelector(
        '.js-styled-select-sitesearch-orderby'
    );
    if (siteSearchOrderButton) {
        const monoSelect = new StyledSelect(siteSearchOrderButton, {
            title: document.querySelector('[data-sitesearchsorton]').dataset
                .sitesearchsorton,
            close: true,
            name: 'mono-sorteerop',
            trigger: '.js-styled-select-trigger-sitesearch-orderby',
            appendTo: '.js-styled-select-wrapper-sitesearch-orderby',
            multiple: false,
            readOnly: false,
            onChange: (styledSelect) => {
                // eslint-disable-next-line no-param-reassign
                styledSelect.trigger.innerText = `${
                    document.querySelector('[data-sitesearchsorton]').dataset
                        .sitesearchsorton
                } ${styledSelect.selection
                    .values()
                    .next()
                    .value.name.toLowerCase()}`;
            },
        });
    }

    const searchButton = document.querySelector(
        '.js-styled-select-sitesearch-sectionfilter'
    );
    if (searchButton) {
        const multiSelectSearch1 = new StyledSelect(searchButton, {
            title: document.querySelector('[data-sitesearchsection]').dataset
                .sitesearchsection,
            close: true,
            name: 'multi-onderwerp',
            trigger: '.js-styled-select-trigger-sitesearch-sectionfilter',
            appendTo: '.js-styled-select-wrapper-sitesearch-sectionfilter',
            multiple: false,
            readOnly: false,
            onChange: (styledSelect) => {
                const innerChange = styledSelect.trigger.querySelector(
                    '.js-button-dropdown-text-select'
                );

                if (
                    styledSelect.selection.values().next().value.value !==
                    'default'
                ) {
                    innerChange.innerText = styledSelect.selection
                        .values()
                        .next().value.name;
                    styledSelect.trigger.classList.add('sub-select-active');

                    resetCrossClick(
                        styledSelect.trigger,
                        document.querySelector('[data-sitesearchsection]')
                            .dataset.sitesearchsection,
                        multiSelectSearch1
                    );
                } else {
                    innerChange.innerText = document.querySelector(
                        '[data-sitesearchsection]'
                    ).dataset.sitesearchsection;
                    styledSelect.trigger.classList.remove('sub-select-active');
                }
            },
        });

        module.exports.siteSearchSectionButton = multiSelectSearch1;
    }

    const multiButton1 = document.querySelector('.js-styled-select');
    if (multiButton1) {
        const multiSelect = new StyledSelect(multiButton1, {
            title: 'Categorie',
            close: true,
            name: 'multi-categorie',
            trigger: '.js-styled-select-trigger',
            appendTo: '.js-styled-select-wrapper',
            multiple: true,
            readOnly: false,
            onChange: (styledSelect) => {
                // const output = document.querySelector('.test')
                // output.innerHTML = ''
                // styledSelect.selection.forEach(entry => {
                //     output.innerHTML += `${entry.value} `
                // })
            },
        });
    }

    const multiSorteer = document.querySelector('.js-styled-select2');
    if (multiSorteer) {
        const monoSorteer = new StyledSelect(multiSorteer, {
            title: 'Sorteer op',
            close: true,
            name: 'mono-sorteer',
            trigger: '.js-styled-select-trigger2',
            appendTo: '.js-styled-select-wrapper2',
            multiple: false,
            readOnly: false,
            onChange: (styledSelect) => {
                // const output = document.querySelector('.test')
                // output.innerHTML = ''
                // styledSelect.selection.forEach(entry => {
                //     output.innerHTML += `${entry.value} `
                // })
            },
        });
    }

    const multiButtonVakgebieden = document.querySelector(
        '.js-styled-select-vakgebieden'
    );
    if (multiButtonVakgebieden) {
        const multiSelectVakgebieden = new StyledSelect(
            multiButtonVakgebieden,
            {
                id: 'categorie',
                title: 'Vakgebieden',
                close: true,
                name: 'multi-vakgebieden',
                trigger: '.js-styled-select-trigger-vakgebieden',
                appendTo: '.js-styled-select-wrapper-vakgebieden',
                multiple: true,
                readOnly: false,
                onChange: (styledSelect) => {},
            }
        );

        module.exports.jobVacancyVakgebiedenButton = multiSelectVakgebieden;
    }

    const multiButtonFunctieGroepen = document.querySelector(
        '.js-styled-select-functiegroepen'
    );
    if (multiButtonFunctieGroepen) {
        const multiSelectFunctieGroepen = new StyledSelect(
            multiButtonFunctieGroepen,
            {
                id: 'functiongroup',
                title: 'Functiegroepen',
                close: true,
                name: 'multi-functiegroepen',
                trigger: '.js-styled-select-trigger-functiegroepen',
                appendTo: '.js-styled-select-wrapper-functiegroepen',
                multiple: true,
                readOnly: false,
                onChange: (styledSelect) => {},
            }
        );

        module.exports.jobVacancyFunctieGroepenButton =
            multiSelectFunctieGroepen;
    }

    const multiButtonOpleidingen = document.querySelector(
        '.js-styled-select-opleidingen'
    );
    if (multiButtonOpleidingen) {
        const multiSelectOpleidingen = new StyledSelect(
            multiButtonOpleidingen,
            {
                id: 'education',
                title: 'Opleidingen',
                close: true,
                name: 'multi-opleidingen',
                trigger: '.js-styled-select-trigger-opleidingen',
                appendTo: '.js-styled-select-wrapper-opleidingen',
                multiple: true,
                readOnly: false,
                onChange: (styledSelect) => {},
            }
        );

        module.exports.jobVacancyOpleidingenButton = multiSelectOpleidingen;
    }

    const multiButtonUren = document.querySelector('.js-styled-select-uren');
    if (multiButtonUren) {
        const multiSelectUren = new StyledSelect(multiButtonUren, {
            id: 'hours',
            title: 'Uren',
            close: true,
            name: 'multi-opleidingen',
            trigger: '.js-styled-select-trigger-uren',
            appendTo: '.js-styled-select-wrapper-uren',
            multiple: true,
            readOnly: false,
            onChange: (styledSelect) => {},
        });

        module.exports.jobVacancyUrenButton = multiSelectUren;
    }

    const multiButtonContractVormen = document.querySelector(
        '.js-styled-select-contractvormen'
    );
    if (multiButtonContractVormen) {
        const multiSelectContractVormen = new StyledSelect(
            multiButtonContractVormen,
            {
                id: 'contracttypes',
                title: 'Contract vormen',
                close: true,
                name: 'multi-contractvormen',
                trigger: '.js-styled-select-trigger-contractvormen',
                appendTo: '.js-styled-select-wrapper-contractvormen',
                multiple: true,
                readOnly: false,
                onChange: (styledSelect) => {},
            }
        );

        module.exports.jobVacancyContractVormenButton =
            multiSelectContractVormen;
    }

    const multiButtonNieuw = document.querySelector('.js-styled-select-nieuw');
    if (multiButtonNieuw) {
        const multiSelectNieuw = new StyledSelect(multiButtonNieuw, {
            id: 'newonly',
            title: 'Nieuw',
            close: true,
            name: 'multi-nieuw',
            trigger: '.js-styled-select-trigger-nieuw',
            appendTo: '.js-styled-select-wrapper-nieuw',
            multiple: true,
            readOnly: false,
            onChange: (styledSelect) => {},
        });

        module.exports.jobVacancyNieuwButton = multiSelectNieuw;
    }

    const categoryButton = document.querySelector(
        '.js-styled-select-news-category-filter'
    );
    if (categoryButton) {
        const monoSelect1 = new StyledSelect(categoryButton, {
            title: document.querySelector('[data-category]').dataset.category,
            close: true,
            name: 'mono1',
            trigger: '.js-styled-select-news-category-trigger',
            appendTo: '.js-styled-select-news-category-wrapper',
            multiple: false,
            readOnly: false,
            onChange: (styledSelect) => {
                const innerChange = styledSelect.trigger.querySelector(
                    '.js-button-dropdown-text-select'
                );
                if (
                    styledSelect.selection.values().next().value.value !==
                    'default'
                ) {
                    innerChange.innerText = styledSelect.selection
                        .values()
                        .next().value.name;
                    styledSelect.trigger.classList.add('sub-select-active');
                    resetCrossClick(
                        styledSelect.trigger,
                        document.querySelector('[data-category]').dataset
                            .category,
                        monoSelect1
                    );
                } else {
                    innerChange.innerText =
                        document.querySelector(
                            '[data-category]'
                        ).dataset.category;
                    styledSelect.trigger.classList.remove('sub-select-active');
                }
            },
        });
    }

    const yearButton = document.querySelector(
        '.js-styled-select-news-year-filter'
    );
    if (yearButton) {
        const yearStyledSelect = new StyledSelect(yearButton, {
            title: document.querySelector('[data-year]').dataset.year,
            close: true,
            name: 'newsyear',
            trigger: '.js-styled-select-news-year-trigger',
            appendTo: '.js-styled-select-news-year-wrapper',
            multiple: false,
            readOnly: false,
            onChange: (styledSelect) => {
                const innerChange = styledSelect.trigger.querySelector(
                    '.js-button-dropdown-text-select'
                );

                if (
                    styledSelect.selection.values().next().value.value !==
                    'default'
                ) {
                    innerChange.innerText = styledSelect.selection
                        .values()
                        .next().value.name;
                    styledSelect.trigger.classList.add('sub-select-active');
                    resetCrossClick(
                        styledSelect.trigger,
                        document.querySelector('[data-year]').dataset.year,
                        yearStyledSelect
                    );
                } else {
                    innerChange.innerText =
                        document.querySelector('[data-year]').dataset.year;
                    styledSelect.trigger.classList.remove('sub-select-active');

                    resetButton(
                        monthSelect.trigger,
                        document.querySelector('[data-month]').dataset.month,
                        monthSelect
                    );
                }
            },
        });
    }

    const monthButton = document.querySelector(
        '.js-styled-select-news-month-filter'
    );
    if (monthButton) {
        monthSelect = new StyledSelect(monthButton, {
            title: document.querySelector('[data-month]').dataset.month,
            close: true,
            name: 'news-month',
            trigger: '.js-styled-select-news-month-trigger',
            appendTo: '.js-styled-select-news-month-wrapper',
            multiple: false,
            readOnly: false,
            onChange: (styledSelect) => {
                const innerChange = styledSelect.trigger.querySelector(
                    '.js-button-dropdown-text-select'
                );

                if (
                    styledSelect.selection.values().next().value.value !==
                    'default'
                ) {
                    innerChange.innerText = styledSelect.selection
                        .values()
                        .next().value.name;
                    styledSelect.trigger.classList.add('sub-select-active');
                    resetCrossClick(
                        styledSelect.trigger,
                        document.querySelector('[data-month]').dataset.month,
                        monthSelect
                    );
                } else {
                    innerChange.innerText =
                        document.querySelector('[data-month]').dataset.month;
                    styledSelect.trigger.classList.remove('sub-select-active');
                }
            },
        });
    }

    const monoButtonSearch1 = document.querySelector(
        '.js-styled-select-search-2'
    );
    if (monoButtonSearch1) {
        const monoSelectSearch1 = new StyledSelect(monoButtonSearch1, {
            title: 'Sorteer op',
            close: true,
            name: 'mono-sorteeropSearch',
            trigger: '.js-styled-select-trigger-search-2',
            appendTo: '.js-styled-select-wrapper-search-2',
            multiple: false,
            readOnly: false,
            onChange: (styledSelect) => {
                // eslint-disable-next-line no-param-reassign
                styledSelect.trigger.innerText = `Sorteer op ${
                    styledSelect.selection.values().next().value.name
                }`;
            },
        });
    }

    const themeButton = document.querySelector(
        '.js-styled-select-news-theme-filter'
    );
    if (themeButton) {
        const monoSelect1 = new StyledSelect(themeButton, {
            title: document.querySelector('[data-theme]').dataset.theme,
            close: true,
            name: 'themes',
            trigger: '.js-styled-select-news-theme-trigger',
            appendTo: '.js-styled-select-news-theme-wrapper',
            multiple: false,
            readOnly: false,
            onChange: (styledSelect) => {
                const innerChange = styledSelect.trigger.querySelector(
                    '.js-button-dropdown-text-select'
                );
                if (
                    styledSelect.selection.values().next().value.value !==
                    'default'
                ) {
                    innerChange.innerText = styledSelect.selection
                        .values()
                        .next().value.name;
                    styledSelect.trigger.classList.add('sub-select-active');
                    resetCrossClick(
                        styledSelect.trigger,
                        document.querySelector('[data-theme]').dataset.theme,
                        monoSelect1
                    );
                } else {
                    innerChange.innerText =
                        document.querySelector('[data-theme]').dataset.theme;
                    styledSelect.trigger.classList.remove('sub-select-active');
                }
            },
        });
    }

    const newsKeywordButton = document.querySelector(
        '.js-styled-select-news-keyword-filter'
    );
    if (newsKeywordButton) {
        const monoSelect1 = new StyledSelect(newsKeywordButton, {
            title: document.querySelector('[data-keyword]').dataset.keyword,
            close: true,
            name: 'keywords',
            trigger: '.js-styled-select-news-keyword-trigger',
            appendTo: '.js-styled-select-news-keyword-wrapper',
            multiple: false,
            readOnly: false,
            onChange: (styledSelect) => {
                const innerChange = styledSelect.trigger.querySelector(
                    '.js-button-dropdown-text-select'
                );
                if (
                    styledSelect.selection.values().next().value.value !==
                    'default'
                ) {
                    innerChange.innerText = styledSelect.selection
                        .values()
                        .next().value.name;
                    styledSelect.trigger.classList.add('sub-select-active');
                    resetCrossClick(
                        styledSelect.trigger,
                        document.querySelector('[data-keyword]').dataset
                            .keyword,
                        monoSelect1
                    );
                } else {
                    innerChange.innerText =
                        document.querySelector(
                            '[data-keyword]'
                        ).dataset.keyword;
                    styledSelect.trigger.classList.remove('sub-select-active');
                }
            },
        });
    }

    // const multiSearch1 = document.querySelector('.js-styled-select-search-1');
    // if (multiSearch1) {
    //     const multiSearchBtn = new StyledSelect(multiSearch1, {
    //         title: 'Onderwerp',
    //         close: true,
    //         name: 'multi-searchbtn',
    //         trigger: '.js-styled-select-trigger-search-1',
    //         appendTo: '.js-styled-select-wrapper-search-1',
    //         multiple: true,
    //         readOnly: false,
    //         onChange: (styledSelect) => {
    //             // styledSelect.trigger.innerText = "Sorteer op " + styledSelect.selection.values().next().value.name
    //         },
    //     });
    // }
};
